/*
  bakos-trio.js
  Scroll-reveal for the 3-panel "Bakos Trio" section (assets/bakos-theme.css: .bakos-trio).
  Vanilla JS, no dependencies — self-contained so it can be dropped into any theme.
  Each panel's text fades + rises into place the first time it enters the viewport,
  staggered by panel index. Respects prefers-reduced-motion.
*/
(function () {
  var prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function reveal(root) {
    var items = root.querySelectorAll('.bakos-trio__item');

    if (prefersReducedMotion || !('IntersectionObserver' in window)) {
      items.forEach(function (item) {
        item.classList.add('is-visible');
      });
      return;
    }

    var observer = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (!entry.isIntersecting) return;
          entry.target.classList.add('is-visible');
          observer.unobserve(entry.target);
        });
      },
      { threshold: 0.25, rootMargin: '0px 0px -10% 0px' }
    );

    items.forEach(function (item, index) {
      item.style.transitionDelay = index * 120 + 'ms';
      observer.observe(item);
    });
  }

  function init() {
    document.querySelectorAll('.bakos-trio').forEach(reveal);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  // Re-init when a section is added/re-rendered in the theme editor.
  document.addEventListener('shopify:section:load', function (event) {
    var section = event.target.querySelector('.bakos-trio');
    if (section) reveal(section);
  });
})();
